import React, {useContext, useState} from 'react';
import {NavLink} from "react-router-dom";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";

const SearchComponent = ({searchName, setSearchName, searchPriority, setSearchPriority}) => {

    const {userStore, priorityStore} = useContext(Context)

    const [activeBurger, setActiveBurger] = useState(false)


    return (
        <div className="search__block">
            <div className="btn__block">
                <button className="btn__block__tasks"><NavLink to="/job/newTask">Создать задачу</NavLink></button>
                {userStore.user.role === 'ADMIN'
                    &&
                    <button><NavLink to="/job/admin_panel">Админ панель</NavLink></button>
                }

            </div>
            <div className="search">

                <select onChange={e => setSearchPriority(e.target.value)} value={searchPriority}
                        className="select__css select__css__search">
                    <option value={''}>Поиск по приоритету</option>
                    {priorityStore.priority.map(priority =>
                        <option
                            onClick={() => setSearchPriority(priority)}
                            key={priority.id}
                            value={priority.id}
                        >
                            {priority.name}
                        </option>
                    )}
                </select>

                <input
                    value={searchName}
                    onChange={event => setSearchName(event.target.value)}
                    type="text"
                    placeholder="Поиск задачи..."
                />
            </div>

            <div className="search__brg">
                <div className="search__brg__title" onClick={() => setActiveBurger(!activeBurger)}>Поиск</div>
                <div className={!activeBurger ? "hamburger" : "hamburger active"}
                     onClick={() => setActiveBurger(!activeBurger)}>
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                </div>
            </div>

            <div className="search__block__brg" style={{left: activeBurger ? '0' : '-100vw'}}>
                <select onChange={e => setSearchPriority(e.target.value)} value={searchPriority}
                        className="select__css select__css__search">
                    <option value={''}>Поиск по приоритету</option>
                    {priorityStore.priority.map(priority =>
                        <option
                            onClick={() => setSearchPriority(priority)}
                            key={priority.id}
                            value={priority.id}
                        >
                            {priority.name}
                        </option>
                    )}
                </select>

                <input
                    value={searchName}
                    onChange={event => setSearchName(event.target.value)}
                    type="text"
                    placeholder="Поиск задачи..."
                />
            </div>

        </div>
    );
};

export default observer(SearchComponent);